/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './selectview.tpl.html';

angular
  .module('metadataCompare.select', [])
  /**
   * Controller for the selectview.tpl.html template.
   */
  .controller(
    'MetadataCompareSelectViewCtrl',
    function (
      $scope,
      $rootScope,
      $window,
      $filter,
      $timeout,
      $state,
      $stateParams,
      $q,
      batchUtils,
      WizardService,
      ALERT_EVENTS,
      METADATA_COMPARE_TYPES,
      METADATA_COMPARE_BATCH_TYPES,
      batchPickers,
      configService
    ) {
      var i18n = $filter('i18n');

      // Register our page with the wizard service
      var page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('COMPARE_METADATA_COMPONENTS'));
      page.setStateParams($stateParams);
      page.setTouched(function () {
        return $scope.touched;
      });
      page.setValid(isValid);
      page.setConfirmLeave(confirmLeavePage);

      $scope.batchPickerStoreLeft = batchPickers[0];
      $scope.batchPickerStoreRight = batchPickers[1];

      $scope.metadataCompareTypes = METADATA_COMPARE_TYPES;
      $scope.metadataCompareBatchTypes = METADATA_COMPARE_BATCH_TYPES;

      $scope.differentDestination = $stateParams.differentDestinationSfId
        ? {
            sfId: $stateParams.differentDestinationSfId,
            name: $stateParams.differentDestinationName
          }
        : null;

      selectCompareAgainst(
        $stateParams.compareAgainst ? parseInt($stateParams.compareAgainst) : METADATA_COMPARE_TYPES.NONE
      );
      $scope.compareAgainstSameOrgBatch = $stateParams.compareAgainstSameOrgBatch
        ? parseInt($stateParams.compareAgainstSameOrgBatch)
        : METADATA_COMPARE_BATCH_TYPES.CURRENT;
      $scope.isPickerDisabled = $scope.compareAgainstSameOrgBatch !== METADATA_COMPARE_BATCH_TYPES.ANOTHER_BATCH;

      // We'll update this as the user interacts with the controls
      $scope.touched = $scope.compareAgainst !== METADATA_COMPARE_TYPES.NONE;

      configService.getConfig().then((config) => {
        $scope.spanningCompareMetadataInfoLink = config.documentationLinks.spanningCompareMetadataInfo;
      });

      // make sure rightBatchId is > leftBatchId
      $scope.$watch(
        function () {
          return $scope.batchPickerStoreLeft.batchObject;
        },
        function (newVal, oldVal) {
          if (batchIsDifferent(newVal, oldVal)) {
            $scope.touched = true;
            validateBatchPicker(newVal.batchId, $scope.batchPickerStoreRight.batchObject.batchId);
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.batchPickerStoreRight.batchObject;
        },
        function (newVal, oldVal) {
          if (batchIsDifferent(newVal, oldVal)) {
            $scope.touched = true;
            validateBatchPicker($scope.batchPickerStoreLeft.batchObject.batchId, newVal.batchId);
          }
        }
      );

      $scope.$watch(
        function () {
          return batchUtils.requestsInProgress;
        },
        function (newVal, oldVal) {
          if (newVal !== oldVal) {
            $rootScope.showLoadingMask = newVal > 0;
          }
        }
      );

      /**
       * Determines whether a picker batch object we're watching has changed.
       *
       * @param {object} newVal - the new batch object
       * @param {object} oldVal - the old batch object
       * @returns {boolean} - true if the batch objects are different.
       */
      function batchIsDifferent(newVal, oldVal) {
        return !!(newVal && oldVal && newVal.batchId !== oldVal.batchId);
      }

      /**
       * Determines whether the selected batches are valid for a compare.
       *
       * @param {number} leftId - the id of the left batch
       * @param {number} rightId - the id of the right batch
       */
      function validateBatchPicker(leftId, rightId) {
        // If we're comparing against the current batch they're always valid
        if ($scope.compareAgainstSameOrgBatch === METADATA_COMPARE_BATCH_TYPES.CURRENT) {
          return;
        }

        if (leftId > rightId) {
          $scope.batchPickerStoreLeft.invalidSelectedDate = true;
          $scope.batchPickerStoreRight.invalidSelectedDate = true;
          $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('COMPARE_AGAINST_NOT_BEFORE_BACKUP'));
        } else {
          $scope.batchPickerStoreLeft.invalidSelectedDate = false;
          $scope.batchPickerStoreRight.invalidSelectedDate = false;
        }
      }

      /**
       * Utility to emit error if invalid date is selected.
       *
       * @param {object} pickerStore - the PickerStore object.
       */
      $scope.invalidDate = function (pickerStore) {
        var removeInvalidOutline = function () {
          pickerStore.invalidSelectedDate = false;
        };

        pickerStore.invalidSelectedDate = true;
        $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('INVALID_DATE'));
        $timeout(removeInvalidOutline, 10000);
      };

      /**
       * Utility method to update selected metadata compare setting.
       * @param {Number} type - The metadata compare setting type.
       */
      function selectCompareAgainst(type) {
        $scope.compareAgainst = type;
        $scope.touched = true;
      }
      $scope.selectCompareAgainst = selectCompareAgainst;

      /**
       * Utility method to update selected batch to compare same org against.
       * @param {Number} type - The metadata batch setting type.
       */
      $scope.selectCompareAgainstSameOrg = function (type) {
        $scope.compareAgainstSameOrgBatch = type;

        if ($scope.compareAgainstSameOrgBatch === METADATA_COMPARE_BATCH_TYPES.CURRENT) {
          $scope.batchPickerStoreLeft.invalidSelectedDate = false;
          $scope.batchPickerStoreRight.invalidSelectedDate = false;
          $scope.isPickerDisabled = true;
        } else {
          $scope.isPickerDisabled = false;
        }

        $scope.touched = true;
      };

      /**
       * Utility method to check if compare against type is the selected type.
       * @param {Number} type - The compare against type.
       * @returns {boolean} - If the radio should be checked.
       */
      $scope.isChecked = function (type) {
        return $scope.compareAgainst === type;
      };

      /**
       * Utility method to check if compare against type is not the selected type.
       * @param {Number} type - The compare against type.
       * @returns {boolean} - If type is not checked.
       */
      $scope.isNotChecked = function (type) {
        return $scope.compareAgainst !== type;
      };

      /**
       * Utility method to check if compare against batch is the selected type.
       * @param {Number} type - The compare against batch type.
       * @returns {boolean} - If the radio should be checked.
       */
      $scope.isCheckedCompareAgainstSameOrg = function (type) {
        return $scope.compareAgainstSameOrgBatch === type;
      };

      /**
       * Utility method to check if selected destination is valid.
       */
      $scope.hasDifferentDestinationSelected = function () {
        return $scope.differentDestination && !_.isEmpty($scope.differentDestination);
      };

      /**
       * Utility method to trim the suffix off the compare against org in a cross org compare.
       *
       * @params {string} sfOrgId - The sfOrgId to trim
       * @returns {string} - the trimmed sfId string
       */
      $scope.trimOrgSuffix = function (sfOrgId) {
        return sfOrgId.indexOf('-') > -1 ? sfOrgId.split('-')[0] : sfOrgId;
      };

      /**
       * Determines whether the settings on the page are valid (i.e. Next is allowed in the wizard)
       *
       * @returns {boolean} true if the settings are valid, false otherwise.
       */
      function isValid() {
        // The user must select same org or cross org
        if ($scope.compareAgainst === METADATA_COMPARE_TYPES.NONE) {
          return false;
        }

        // If its a same org compare, the right batchId MUST be greater than the left batchId
        if (
          $scope.compareAgainst === METADATA_COMPARE_TYPES.SAME_ORG_COMPARE &&
          $scope.compareAgainstSameOrgBatch === METADATA_COMPARE_BATCH_TYPES.ANOTHER_BATCH
        ) {
          return $scope.batchPickerStoreRight.batchObject.batchId > $scope.batchPickerStoreLeft.batchObject.batchId;
        }

        // If its cross org we need a right side org id
        if ($scope.compareAgainst === METADATA_COMPARE_TYPES.CROSS_ORG_COMPARE) {
          return !!$scope.differentDestination && !_.isEmpty($scope.differentDestination);
        }

        return true;
      }

      /**
       * Set the state params for the next state - all the info we need from this state to pass to server.
       *
       * @returns {Promise} a promise that is resolved if it's ok to leave the page.
       */
      function confirmLeavePage() {
        if (!isValid()) {
          return $q.reject();
        }

        $stateParams.compareAgainst = $scope.compareAgainst;
        $stateParams.differentDestinationSfId =
          $scope.differentDestination && !_.isEmpty($scope.differentDestination)
            ? $scope.differentDestination.sfId
            : null;
        // just need to pass the name back and forth for display purposes
        $stateParams.differentDestinationName =
          $scope.differentDestination && !_.isEmpty($scope.differentDestination)
            ? $scope.differentDestination.name
            : null;
        $stateParams.batchPickerStoreLeftBatchId = $scope.batchPickerStoreLeft.batchObject.batchId;
        $stateParams.batchPickerStoreRightBatchId = $scope.batchPickerStoreRight.batchObject.batchId;
        $stateParams.compareAgainstSameOrgBatch = $scope.compareAgainstSameOrgBatch;

        return $q.when();
      }

      /**
       * Function to open modal to add new org to compare against.
       * @param {boolean} [isSandBox=false] - Flag to get correct url login for sand box orgs
       */
      $scope.addCompareAgainstOrg = function (isSandBox) {
        var height = 500,
          width = 650,
          x = $window.screen.width / 2 - width / 2,
          y = $window.screen.height / 2 - height / 2;

        isSandBox = isSandBox || false;

        if ($scope.compareAgainst === METADATA_COMPARE_TYPES.CROSS_ORG_COMPARE) {
          $window.open(
            '/login/crossorg?isSandBox=' + isSandBox,
            'SBSF-Salesforce-Oauth',
            'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,height=' +
              height +
              ',width=' +
              width +
              ',left=' +
              x +
              ',top=' +
              y
          );
        }
      };
    }
  );
